import { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Dropzone from 'react-dropzone'
import FocusTrap from 'focus-trap-react'

const StyledDropzone = styled.div`
  outline: none !important;
  ${props => (props.disabled ? `pointer-events: none;` : '')}
  * {
    outline: none !important;
  }
`

const CustomDropzone = ({
  disabled,
  trap,
  type,
  accept,
  allowBulk,
  noClick,
  onDrop,
  onError,
  children,
}) => {
  const node = useRef()
  const [isFocused, setIsFocused] = useState(false)

  const handleOnDrop = files => {
    if (!disabled) {
      const mostRecentFile = files[files.length - 1]

      let allValid = true

      if (!accept.includes('*')) {
        if (allowBulk) {
          files.forEach(file => {
            if (!accept.includes(file.type)) allValid = false
          })
        } else {
          if (!accept.includes(mostRecentFile.type)) allValid = false
        }
      }

      if (allValid) {
        onDrop(allowBulk ? files : mostRecentFile)
      } else {
        onError('Incorrect file type')
      }
    }
    setIsFocused(false)
  }

  return (
    <FocusTrap active={isFocused}>
      <StyledDropzone
        disabled={disabled}
        ref={node}
        tabIndex="0"
        onMouseDown={() => {
          if (!noClick) setIsFocused(true)
        }}
      >
        <Dropzone
          onDrop={handleOnDrop}
        >
          {({ getRootProps, getInputProps }) => 
            (
              <div
                {...getRootProps({
                  onClick: e => {
                    if (noClick) e.stopPropagation()
                  },
                })}
              >
                <input
                  {...getInputProps()}
                />
                {children}
              </div>
            )}
        </Dropzone>
      </StyledDropzone>
    </FocusTrap>
  )
}

CustomDropzone.propTypes = {
  disabled: PropTypes.bool,
  trap: PropTypes.bool,
  type: PropTypes.string,
  accept: PropTypes.array,
  allowBulk: PropTypes.bool,
  noClick: PropTypes.bool,
  onDrop: PropTypes.func,
  onError: PropTypes.func,
  // file: PropTypes.file,
}

CustomDropzone.defaultProps = {
  disabled: false,
  type: 'file',
  // image/png | image/jpeg | application/pdf | text/csv
  accept: ['*'],
  onDrop: () => {},
  onError: () => {},
}

export default CustomDropzone
